export default function Editorial() {
  return (
    <section id="zhuanlan" className="scroll-mt-20 bg-foreground-950 text-white">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:gap-14">
          {/* featured spread image */}
          <div className="relative overflow-hidden rounded-xl">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20magazine%20spread%20photograph%20of%20an%20open%20book%20and%20glasses%20on%20a%20warm%20wooden%20desk%20under%20soft%20amber%20lamp%20light%20with%20scattered%20printed%20newspaper%20clippings%2C%20cinematic%20photography%2C%20terracotta%20crimson%20and%20cream%20palette%2C%20moody%20shadows%2C%20high%20detail%20reportage%20style&width=1200&height=800&seq=ed-spread-01&orientation=landscape"
              alt="主编专栏配图：编辑台与档案剪报"
              title="主编专栏 - 嘿料吃瓜"
              className="h-full min-h-[320px] w-full object-cover object-top"
            />
            <div className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-3 bg-gradient-to-t from-foreground-950/90 to-transparent p-5 md:p-6">
              <div>
                <p className="text-[11px] font-bold tracking-[0.3em] text-accent-400 uppercase">本期专栏 · 方法论</p>
                <p className="font-heading text-lg font-black md:text-xl">吃瓜也要讲基本盘</p>
              </div>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/25 text-accent-400">
                <i className="ri-double-quotes-l text-xl" />
              </span>
            </div>
          </div>

          {/* editor column text */}
          <div className="flex flex-col justify-center gap-5">
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.3em] text-accent-400 uppercase">
              <span className="h-px w-6 bg-accent-500" />
              主编导读 · Editor's Note
            </span>
            <blockquote className="font-heading text-2xl font-black leading-relaxed text-white md:text-3xl">
              「一个瓜的正确打开方式，
              <span className="text-accent-400">不是冲上去骂人</span>
              ，而是先把它读完。」
            </blockquote>
            <p className="dropcap text-sm leading-[1.9] text-white/75 md:text-base">
              做这本周刊档案以来，我见过太多在一句话截图前就急着站队的人。截图不撒谎，但断章取义会。本期我们把三件「看起来毫无关系」的塌房，按照同一套舆论引擎拆开，
              你会在最后发现：爆点、反转、清场，其实都是同一台机器里的齿轮。
            </p>
            <p className="text-sm leading-[1.9] text-white/75 md:text-base">
              档案的意义，是把「义愤填膺的那一分钟」拉长成「愿意读十分钟的耐心」。当流量退潮，只有把事情讲完整的人，还留在岸边。
            </p>
            <div className="grid gap-3 sm:grid-cols-3">
              {[
                { n: "①", t: "先看全须全尾" },
                { n: "②", t: "再分阵营与利益" },
                { n: "③", t: "最后才谈立场" },
              ].map((s) => (
                <div key={s.n} className="rounded-md border border-white/15 bg-white/5 p-3.5">
                  <span className="font-display text-lg font-bold text-accent-400">{s.n}</span>
                  <p className="mt-1 text-sm font-medium text-white/85">{s.t}</p>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-4 border-t border-white/10 pt-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 font-heading text-lg font-black text-foreground-950">
                嘿
              </span>
              <div>
                <p className="text-sm font-bold text-white">本期轮值主编 · 老瓜农</p>
                <p className="text-xs text-white/60">在瓜田里种了七年档案的老编辑</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}